





















import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

/**
 * Wrapper for a v-icon that provides extra style
 * types and hover/focus/active styles
 */
@Component({ name: 'v-icon-button' })
export default class VIconButton extends Mixins(Modifiable) {
    /**
     * Icon name
     *
     * Reference: https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'question-circle' })
    icon!: string

    /**
     * Style type
     */
    @Prop({ type: String, default: 'primary-dark' })
    type!: 'primary-dark'
        | 'primary'
        | 'primary-solid'
        | 'primary-light'
        | 'primary-dark-light'
        | 'dark-to-primary'
        | 'primary-to-error'
        | 'dark-to-error'
        | 'primary-ghost'
        | 'error-to-light'
        | 'light'
        | 'error'
        | 'menu'
        | 'primary-circle'
        | 'white'
        | 'white-dull'
        | 'black-dull'
        | 'primary-dull'

    /**
     * Icon size
     */
    @Prop({ type: String, default: 'md' })
    size!: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

    /**
     * At which brightness to invert the colours
     */
    @Prop({ type: String })
    invert!: 'light' | 'dark'

    /**
     * Button container size
     */
    @Prop({ type: String, default: 'md' })
    containerSize!: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

    /**
     * Whether the button is a pill (has rounded edges)
     */
    @Prop({ type: Boolean, default: false })
    pill!: boolean

    /**
     * Whether to use a solid icon
     */
    @Prop({ type: Boolean, default: true })
    solid!: boolean

    /**
     * Button title
     */
    @Prop({ type: String, default: '' })
    title!: string
}
